export default function () {
    const supplyChainData = {
        recycle: [
            {
                company: {
                    companyId: 1,
                    logoUrl: require('@/assets/png/chainCompany/recycle/company-logo-1.png'),
                    name: '宏恩塑膠股份有限公司',
                    introduction:
                        '宏恩創立於1980年，已擁有超過40年的再生塑膠處理經驗及專業技術。年處理量從草創之初700噸，擴增至目前每年可有效處理5萬噸以上。業務範圍為PP、PE、ABS、PS、PC、PET(紗、片)等新舊料買賣。\n\
                        近年，海廢問題嚴重，而宏恩身為資源回收再利用業者，於2019年開始投入解決台灣不易處理的海洋廢棄物，包括漁網、漁業浮筒、保麗龍、瓶罐塑膠等等。進入宏恩的再生廠後，通過品質檢測，再經過清洗、分類、及熔融，最後產出100%的海廢再生塑膠粒。 經驗證的海廢再生塑膠材質包括：PP、PE、PA、ABS及PS。\n\
                        針對不同特性的塑膠，開發出多種用途的再生料，涵蓋吹瓶級、吹袋級、押出級與射出級等，且提供客製化配料與染色服務。宏恩產出的再生塑膠品質達90%媲美新料等級，可應用於各類瓶罐、袋子、家用產品、建材、電子產品、辦公用品、汽車零部件以及運動用品等等多種選擇。宏恩本著初衷：「誠信、務實、責任、創新」，在最不起眼的地方，堅持做對地球有益的事，全心推廣循環經濟，賦予再生塑膠更高的價值。',
                },
                contact: {
                    name: '洪詠華',
                    department: '管理部',
                    jobTitle: '組長',
                    phone: '04-8966172#85',
                    email: 'ann_hung@horngen.com',
                },
                recycle: {
                    types: ['PET 寶特瓶', 'PP 容器', 'PE 容器', 'PA 尼龍', 'PS, ABS'],
                    allowedStandard: '需按材質分類、雜質(不可回收)盡可能去除，可協助材質認定',
                    allowedRange: '皆可',
                },
            },
            {
                company: {
                    companyId: 2,
                    logoUrl: require('@/assets/png/chainCompany/recycle/company-logo-2.png'),
                    name: '合力旺再利用有限公司',
                    introduction:
                        '合力旺再利用有限公司成立於民國九十九年八月，工廠位於楊梅市的富岡，是：家專業處理保麗龍廢棄物的廠商，近年來亦有代工PP、PS 抽粒的業務。\n\
                        合力旺再利用有限公司的前身為隆泰興保麗龍有限公司的蘆竹分公司，隆泰興本身是一家專業生產保麗龍板的工廠，蘆竹分公司則負責保麗龍回收的業務。\n\
                        民國九十九年時，為因應日趨嚴格的環保法規，公司決定成立合力旺再利用有限公司來專門負責保麗龍回收業務。\n\
                        董事長陳連棖先生認為我們客戶的事業興旺，公司自然就會跟著興旺，故以台語的諧音「虎你旺」作為公司名稱，同時也有大家同心協力就會興旺的意涵。',
                },
                contact: {
                    name: '陳嵩淵',
                    department: '管理部',
                    jobTitle: '總經理',
                    phone: '03-4725666',
                    email: 'unione.recycle@gmail.com',
                },
                recycle: {
                    types: ['保麗龍'],
                    allowedStandard: 'PS/PP/PO 材質',
                    allowedRange: '新北市/台北市/桃園市/新竹',
                },
            },
        ],
        manufacture: [
            {
                company: {
                    companyId: 1,
                    logoUrl: require('@/assets/png/chainCompany/manufacture/company-logo-1.jpeg'),
                    name: '世堡紡織股份有限公司',
                    introduction:
                        '世堡紡織成立於1975年，不僅為成衣業界提供契合時尚的布料，在特殊工業用布、科技用布、椅套用布的研發上，更投注大量心血，成為我國優秀的紡織企業，並成為世界龍頭紡織企業的主要供應商。世堡於1997年帥業界先鋒投入寶特瓶（保特瓶）（可樂瓶）回收纖維及布料的開發，將回收的寶特瓶經過一系列製程做成環保再生織物，但由於發展速度過快，而市場尚未成熟，曲高和寡加上供應鏈上游製程控管不易，所以價格偏高，未能普及。直至2003年成果獲得各界迴響，這歸功於上下游企業整合共同努力的結果。\n\
                        \n\
                        業務包括：各種特殊功能用布-寶特瓶環保再生布，遠紅外線，吸濕快乾，抗菌防臭，防污，抗靜電防焰，夜光布，超細纖維，竹炭纖維，抗UV...等等複合功能。',
                },
                contact: {
                    name: '黃唯甯',
                    department: '研發部',
                    jobTitle: '研發',
                    phone: '02-25117157',
                    email: 'sophie@supertextile.tw',
                },
                recycle: {
                    types: ['PET 寶特瓶'],
                },
                product: {
                    types: [''],
                },
            },
            {
                company: {
                    companyId: 2,
                    logoUrl: require('@/assets/png/chainCompany/manufacture/company-logo-2.png'),
                    name: '豐溢綠能材料股份有限公司',
                    introduction:
                        '2021年於彰化縣芳苑鄉成立，以循環經濟發展的思維，組成PCR高質(值)材料供應聯盟，並以環境關懷、技術先進及創新思維為核心價值。希望以友善環境及高質化應用的方式，提供製造商可被驗證的PCR材料。\n\
                        \n\
                        因此豐溢綠能可提供客戶完整的再生塑膠解決方案，擁有專業的研發團隊與設備，可依照客戶需求提供消費後再生(PCR)的再生料。 營業項目有：◎PCR再生塑膠粒子製造(rPP、rPE、rPS等) ◎塑膠製品導入再生塑膠顧問服務 ◎再生塑膠國際貿易 ◎海廢再生材料PS、PA研究開發◎再生塑膠改質、研發、客製化服務。',
                },
                contact: {
                    name: '張福麟',
                    department: '營銷部',
                    jobTitle: '經理',
                    phone: '04-8932525＃240',
                    email: 'raymond@globalgreenmaterial.com',
                },
                recycle: {
                    types: ['PE 容器', 'PS'],
                },
                product: {
                    types: ['碎片'],
                },
            },
            {
                company: {
                    companyId: 3,
                    logoUrl: require('@/assets/png/chainCompany/manufacture/company-logo-3.png'),
                    name: '	寶綠特資源再生科技股份有限公司',
                    introduction:
                        '於1991年在台灣成立聚酯回收清洗廠，已累積20年PET及其它塑料瓶回收處理和15年聚酯短纖生產經驗，致力於塑料回收技術研究開發及再生物資綜合利用，並逐步邁向「再生聚酯產業鏈資源與技術整合者」之目標。\n\
                        \n\
                        豐富的製造經驗成為規劃、設計與製造塑料環保機械的最大支柱。尤其在PET瓶再生回收的領域上，除提供整廠輸出或單一設備之技術外，也實際營運再生PET、PP各類原料及上下游產品之製造、銷售。',
                },
                contact: {
                    name: '劉佩琪',
                    department: '營業部',
                    jobTitle: '營業專員',
                    phone: '06-6233306＃219',
                    email: 'peggy.liu@bo-re-tech.com',
                },
                recycle: {
                    types: ['PET 寶特瓶', 'PP 容器'],
                },
                product: {
                    types: ['顆粒', '碎片'],
                },
            },
            {
                company: {
                    companyId: 4,
                    logoUrl: require('@/assets/png/chainCompany/manufacture/company-logo-4.png'),
                    name: '宏恩塑膠股份有限公司',
                    introduction:
                        '宏恩創立於1980年，已擁有超過40年的再生塑膠處理經驗及專業技術。年處理量從草創之初700噸，擴增至目前每年可有效處理5萬噸以上。業務範圍為PP、PE、ABS、PS、PC、PET(紗、片)等新舊料買賣。\n\
                        近年，海廢問題嚴重，而宏恩身為資源回收再利用業者，於2019年開始投入解決台灣不易處理的海洋廢棄物，包括漁網、漁業浮筒、保麗龍、瓶罐塑膠等等。進入宏恩的再生廠後，通過品質檢測，再經過清洗、分類、及熔融，最後產出100%的海廢再生塑膠粒。 經驗證的海廢再生塑膠材質包括：PP、PE、PA、ABS及PS。\n\
                        針對不同特性的塑膠，開發出多種用途的再生料，涵蓋吹瓶級、吹袋級、押出級與射出級等，且提供客製化配料與染色服務。宏恩產出的再生塑膠品質達90%媲美新料等級，可應用於各類瓶罐、袋子、家用產品、建材、電子產品、辦公用品、汽車零部件以及運動用品等等多種選擇。宏恩本著初衷：「誠信、務實、責任、創新」，在最不起眼的地方，堅持做對地球有益的事，全心推廣循環經濟，賦予再生塑膠更高的價值。',
                },
                contact: {
                    name: '洪詠華',
                    department: '管理部',
                    jobTitle: '組長',
                    phone: '04-8966172#85',
                    email: 'ann_hung@horngen.com',
                },
                recycle: {
                    types: ['PET 寶特瓶', 'PP 容器', 'PE 容器', 'PA 尼龍', 'PS、ABS'],
                },
                product: {
                    types: ['顆粒'],
                },
            },
            {
                company: {
                    companyId: 5,
                    logoUrl: require('@/assets/png/chainCompany/manufacture/company-logo-5.png'),
                    name: '合力旺再利用有限公司',
                    introduction:
                        '合力旺再利用有限公司成立於民國九十九年八月，工廠位於楊梅市的富岡，是：家專業處理保麗龍廢棄物的廠商，近年來亦有代工PP、PS 抽粒的業務。\n\
                        合力旺再利用有限公司的前身為隆泰興保麗龍有限公司的蘆竹分公司，隆泰興本身是一家專業生產保麗龍板的工廠，蘆竹分公司則負責保麗龍回收的業務。\n\
                        民國九十九年時，為因應日趨嚴格的環保法規，公司決定成立合力旺再利用有限公司來專門負責保麗龍回收業務。\n\
                        董事長陳連棖先生認為我們客戶的事業興旺，公司自然就會跟著興旺，故以台語的諧音「虎你旺」作為公司名稱，同時也有大家同心協力就會興旺的意涵。',
                },
                contact: {
                    name: '陳嵩淵',
                    department: '管理部',
                    jobTitle: '總經理',
                    phone: '03-4725666',
                    email: 'unione.recycle@gmail.com',
                },
                recycle: {
                    types: ['PP 容器', 'PS、PO'],
                },
                product: {
                    types: ['顆粒'],
                },
            },
            {
                company: {
                    companyId: 6,
                    logoUrl: require('@/assets/png/chainCompany/manufacture/company-logo-6.png'),
                    name: '台捷精密股份有限公司',
                    introduction:
                        '將熱塑性塑料、植物纖維、廢棄衣服、海洋廢棄塑料等回收再利用材料，選擇配比做成〝捷綠木〞並應用於不同領域，是台捷精密(股)公司的專業生產製造技術。台捷烯彈性體粒料、捷綠木角板材、捷綠木生產技術對外輸出、打造從原料到商品複式循環經濟示範區是台捷精密(股)公司的主要對外營運項目。要同時解決：各區域熱塑性塑料垃圾堆積對環境造成之危害，世界各國對木材需求且又能讓森林不再砍筏獲得回復等問題。無疑的捷綠木生產工藝是為地球環境改善提供一個很好的途徑。',
                },
                contact: {
                    name: '楊政韋',
                    department: '工程部',
                    jobTitle: '工程師',
                    phone: '0953-681272',
                    email: 'leon.hi@msa.hinet.net',
                },
                recycle: {
                    types: ['PET 寶特瓶', 'PS'],
                },
                product: {
                    types: ['塑木板材、角材'],
                },
            },
            {
                company: {
                    companyId: 7,
                    logoUrl: require('@/assets/png/chainCompany/manufacture/company-logo-7.png'),
                    name: '海神全球股份有限公司',
                    introduction:
                        '海神全球透過化學性回收之熱裂解技術，我們將回收的廢塑膠化學性處理轉換成新的再生油品與再生碳：燃料油，熱裂解油及再生碳。油品可用於再生塑膠源料，燃油使用等。再生碳也可用於傳統碳黑可使用的用途。這是解決日積月累的塑膠垃圾和空汙問題的最佳方式。我們是少數能透過化學性回收-熱裂解技術達成高轉換率並達到低排放減碳排，對環境極低負擔的公司。\n\
                        海神PSD再生碳為百分百回收料製成。其中包含近4成的海廢漁網，與超過6成的廢塑膠。此再生碳用途廣汎，不止是可用於碳鋼製造，泊油路，更可用於上色的其他用途。采用此產品可幫助減少海廢與鼓勵更多廠商與政府機關去做更多回收海廢的活動，推動台灣海洋廢棄物循環再利用，領先全球！',
                },
                contact: {
                    name: '林志陽',
                    department: '生產部',
                    jobTitle: '副總經理',
                    phone: '03-3859800',
                    email: 'j.lam@psdindustry.com',
                },
                recycle: {
                    types: ['PP', 'PE', 'PS', 'PA', '其他'],
                },
                product: {
                    types: ['其他'],
                },
            },
            {
                company: {
                    companyId: 8,
                    logoUrl: require('@/assets/png/chainCompany/manufacture/company-logo-8.png'),
                    name: '樺奕塑膠工業股份有限公司',
                    introduction:
                        '樺奕從 2004 年從清運塑膠開始創業，後來將其破碎洗淨後銷售，再進階到針對各類再生塑料造粒的改質及調色。在不斷地精進學習與擴大規模後，正式於 2009 年創立「樺奕塑膠工業有限公司」，目前 主要銷售 ABS 、 PS 、 PC 、 PC/ABS及 POM 環保再生塑膠原料。基於 公司的理念與純熟的技術及經驗，可以提供客戶在使用環保塑膠原料上的各種需求。\n\
                        有鑑於世界環保意識抬頭，以及塑膠對海洋環境造成的破壞汙染，讓同為塑膠產業的我們決定全面投入再生塑膠的回收、研發與製造。我們收集所有廢料塑膠，並且加以分類、破碎、洗淨、篩選、染色、改性以符合品牌客戶對綠色產品的要求。除了讓廢棄塑膠能夠偱環再生之外，並保有良好穩定的品質，提供客戶優良的綠色產品。同時樺奕也會不斷研發產品，以達到消費後塑膠能百分百回收再利用，期望以台灣人努力不懈的精神，能為這地球盡一份心力，且在世界舞台上脫穎而出。',
                },
                contact: {
                    name: '葉品岑',
                    department: '產品專案部',
                    jobTitle: '',
                    phone: '0987860973',
                    email: 'pinpin.yeh@huayi-tw.com',
                },
                recycle: {
                    types: ['EPS'],
                },
                product: {
                    types: ['顆粒'],
                },
            },
            {
                company: {
                    companyId: 9,
                    logoUrl: require('@/assets/png/chainCompany/manufacture/company-logo-9.png'),
                    name: '松萬企業有限公司仁德廠',
                    introduction:
                        '松萬企業有限公司-成立於2018年，並於2019年取得環保再利用執照，我們擁有訓練有素的工作夥伴及專業的檢測儀器以提供客戶最優質的產品並滿足客戶的需求，本公司主要回收PP、PE及PA漁網，專業生產粉碎與造粒，產品主要為外銷導向,歐美日大陸為主要銷售國本公司提供優良的產品與精良的服務 進口或者出口均有相關證照與再利用相關證照',
                },
                contact: {
                    name: '林義証',
                    department: '',
                    jobTitle: '負責人',
                    phone: '062795111',
                    email: '',
                },
                recycle: {
                    types: ['PP', 'PE', 'PA'],
                },
                product: {
                    types: ['粒子'],
                },
            },
            {
                company: {
                    companyId: 10,
                    logoUrl: '',
                    name: '金洲海洋科技股份有限公司',
                    introduction:
                        '自1978年的「金洲製網」開始，直到現在的「金洲海洋科技」，不斷地致力於產品研發和技術創新，提供完善的顧客服務，成就了金洲海洋科技的世界品牌地位。至今，金洲海洋科技仍然秉持最初的理想；以網絡連結希望與豐收，提供客戶最好的產品和服務。位於台灣屏東縣的新園廠，是金洲第一座工廠，緊繫著金洲穩固的基礎。位於屏南工業區的屏南廠，是專為大型圍網提供組裝服務的廠區。1994年，中國昆山廠開始投入量產，將金洲推向全球前三大製網廠的高峰。為了因應更多客戶需求，2008年，在越南設廠，增購最新設備器材，使金洲的產品線更加完整。於2012年遷至昆山周市廠，以更大場地和更新的機械設備，提供全球客戶和中國內需客戶更便捷的在地組裝服務。金洲以多年的技術與經驗，生產各種海上漁業所需網具，從拖網、流刺網、陷阱網、定置網、箱網，美式大型圍網及各類型圍網。金洲採用世界知名化工纖維大廠所生產的特殊黑色原絲；製造出的各種圍網，具有更高的耐磨性與高拉力，是一般尼隆材質無法比擬的；深獲客戶的信賴。金洲的圍網團隊能從設計、製網、組合到售後服務完整配合，以最快最優質的服務滿足客戶需求。地球面臨海洋資源枯竭危機之際，箱網養殖是未來漁業的替代方式，金洲因此更積極重視箱網開發與製造，箱網的網片特別引進超高拉力原絲編織，能夠耐水深20公尺以上的深海惡劣氣候與防掠食動物咬破，大幅降低養殖戶的損失。各種箱網組合方式皆可提供客製化規格組合服務及整場規劃。金洲同時也歡迎各種陸地用網的訂製，各類運動用網，有棒球網/網球網/足球網/高爾夫球網/安全網等網具。無論是海上用漁網或陸上用網，我們與客戶密切溝通，隨時改善設計，配合用戶提供規劃組裝服務。金洲海洋科技，在繁複的生產線上嚴格把關，從原料抽絲、盤繞撚線、各種尺寸網片編織、層層品管巡捕，經漂染與網目定型，在生產過程中，不斷的抽樣進行拉力測試，確保品質穩定。接著各類型網具加工組合，從生產到包裝出貨的每一個步驟，皆有金洲嚴格的品質把關，這也是金洲海洋科技引以為傲的優勢，擁有完整的生產線，才能提供來自全球的客戶最豐富的客製化產品。金洲海洋科技以自有品牌「King Net」的網具行銷世界，同時也提供代工生產、設計代工等服務。金洲海洋科技自創辦三十多年來對於產品品質、創新及研發一直相當堅持，金洲的產品銷售於世界各地，我們的品質也受到國際間各項認證的肯定，接下來下一步著重在研發能力及機器設備的更新，開發出差異化的產品，讓金洲海洋科技的領先地位，永續經營下去。',
                },
                contact: {
                    name: '陳美莉',
                    department: '資訊室',
                    jobTitle: '協理',
                    phone: '07-5352939',
                    email: 'kingnet@mail.king-net.com.tw',
                },
                recycle: {
                    types: ['PA'],
                },
                product: {
                    types: ['其他：尼龍材質網片、繩索'],
                },
            },
            {
                company: {
                    companyId: 11,
                    logoUrl: require('@/assets/png/chainCompany/manufacture/company-logo-11.png'),
                    name: '益鈞環保科技股份有限公司',
                    introduction:
                        '`益鈞環科創立源自於母公司益州集團之理念，以「環境永續」為經營目標。益州集團多年來默默不斷執行各項循環經濟相關產業，如廢棄油品、廢玻璃等再利用，均不斷尋求各種資源永續的環境友善方式。\n\
                        \n\
                        益鈞環科制定了一套完善的循環再利用方案，讓尿布廢棄物的終點重新給予活化契機，也同時投入海洋環境保護，透過整合海廢回收、再生處理，促進資源的共享、技術的交流和共同應對海洋垃圾的努力，串連了上下游產業鍊，實證了還原材料再製的各項案例。',
                },
                contact: {
                    name: '沈國芬',
                    department: '業務部',
                    jobTitle: '副總經理',
                    phone: '03-3541700 #103',
                    email: 'jennifer@yichungt.com',
                },
                recycle: {
                    types: ['PP', 'PE'],
                },
                product: {
                    types: ['粒子'],
                },
            },
            {
                company: {
                    companyId: 12,
                    logoUrl: '',
                    name: '台灣糖業股份有限公司生物科技事業部-生技材料廠',
                    introduction:
                        '台糖公司生物科技事業部於92年成立，以既有的醱酵技術為基礎，設置微生物醱酵、天然物萃取及產品包裝等設備，所有製程均符合國際水準與規範。因應高齡化社會及潮流，積極投資發展保健食品、機能飲品及美容保養品，同時提供國內酒精銷售，並提供代客加工。本事業部致力產品品質及安全，更榮獲ISO 9001、ISO 14001、ISO 22000、HACCP、TOSHMS、TQF、化粧品GMP及健康食品等認證，守護國人健康之外，今更以牡蠣殼製成碳酸鈣，努力實踐循環經濟，創新材料與專材、技術產品等，並樂意與海外合作，本持友善環境，期許共榮、共存，共創美好未來。',
                },
                contact: {
                    name: '陳威任',
                    department: '生物科技事業部',
                    jobTitle: '副執行長',
                    phone: '0935-587-119',
                    email: 'a63105@taisugar.com.tw',
                },
                recycle: {
                    types: ['其他'],
                },
                product: {
                    types: ['其他-碳酸鈣原料'],
                },
            },
            {
                company: {
                    companyId: 13,
                    logoUrl: require('@/assets/png/chainCompany/manufacture/company-logo-13.jpg'),
                    name: '億薈塑膠企業有限公司',
                    introduction:
                        '億薈塑膠企業有限公司為專業尼龍複合材回收再生料製造廠，公司成立於2003年，座落於台南市關廟區。公司初期專業單純回收尼龍下腳料製成再生基礎塑粒，在2008年投入複合材生產設備，開啟從回收到尼龍複合材料的研發與改質服務。而於2010年為了擴大回收再利用及廢棄物變黃金的訴求，開始接觸海廢回收料，自此投入海廢原料各項產品應用與研發，打造循環經濟共生共享新文化。我們致力於尼龍回收再生料的分類應用與研發改質，主要營業項目為尼龍6、尼龍66、工程塑膠及複合材料，透過尖端尼龍工程塑料的持續研發，滿足客戶對於堅韌、彈性、輕量、延展、耐候、耐熱、耐高衝擊、耐低溫衝擊等各式應用需求，豐富複合材料的應用可能，提供客戶專業用料諮詢及客製化解決方案。',
                },
                contact: {
                    name: '曾詩雯',
                    department: '品保部',
                    jobTitle: '副理',
                    phone: '06-5961155#30',
                    email: 'QMS@rebornplas.com',
                },
                recycle: {
                    types: ['PA'],
                },
                product: {
                    types: ['粒子'],
                },
            },
            {
                company: {
                    companyId: 14,
                    logoUrl: require('@/assets/png/chainCompany/manufacture/company-logo-14.jpg'),
                    name: '喬瓏企業股份有限公司',
                    introduction: '',
                },
                contact: {
                    name: '陳俊傑',
                    department: '',
                    jobTitle: '',
                    phone: '0919033520',
                    email: 'Jack.annie@yahoo.com.tw',
                },
                recycle: {
                    types: ['PA', '尼龍'],
                },
                product: {
                    types: ['顆粒'],
                },
            },
        ],
        brand: [
            {
                company: {
                    companyId: 1,
                    logoUrl: require('@/assets/png/chainCompany/brand/company-logo-1.png'),
                    name: '綠藤生物科技股份有限公司',
                    introduction:
                        '關於綠藤生機\n\
                        \n\
                        成立於 2010 年的綠藤生機，以「二減一加」的深入減法的純淨保養 — 減去非必要程序、減去超過 2,900 種非必要成分，加上必要的透明，挑戰保養慣例。從洗沐到臉部保養僅 22 款產品，讓每天的保養，成為肌膚與環境永續的可能。綠藤也是亞洲唯一、連續五度獲得「對世界最好（Best for the World）」環境面項大獎的 B 型企業。\n\
                        頭皮淨化洗髮精 海廢再生瓶\n\
                        \n\
                        2022 年初，綠藤展開了一場挑戰：希望讓更多台灣在地的廢棄漁網進入回收再生循環、減少海洋負擔 ……\n\
                        耗時半年、串連 5 家供應鏈夥伴投入，終於使來自從台中梧棲港蒐集的 1,800 公斤的廢棄漁網，獲得第二生命，再次循環利用。\n\
                        「頭皮淨化洗髮精 海廢再生瓶」瓶器不僅由 100% 再生塑膠、高比例 33% 海洋廢棄物製成，並於 10 月獲得了環保署認證「海洋廢棄物循環產品標章」，第一支來自台灣的海廢再生洗髮精誕生！',
                },
                contact: {
                    name: '余宛樺',
                    department: '供應鏈',
                    jobTitle: '採購專員',
                    phone: '02-27076788 #115',
                    email: 'gina.yu@greenvines.com.tw',
                },
                product: {
                    types: ['日常用品類'],
                },
            },
            {
                company: {
                    companyId: 2,
                    logoUrl: '',
                    name: '藍洋綠藝創作坊(台東縣成功鎮石雨傘部落)',
                    introduction:
                        '漁業浮球是漁網必要裝備，每年有數以萬計的浮球被棄置，隨風浪漂到海岸，是常見的海洋廢棄物，影響海洋與海岸的生態。工藝家吳寬亮結合原鄉部落居民環保意識與藝術天份，在臺東縣成功鎮石雨傘部落裡的藍洋綠藝創作坊辦理創作課程，將海廢浮球、漁網等海洋廢棄物再製成燈罩、裝置藝術品，讓海廢能夠再利用。',
                },
                contact: {
                    name: '吳寬亮',
                    department: '',
                    jobTitle: '負責人',
                    phone: '0970-269-917',
                    email: 'ben0970269917@gmail.com',
                },
                product: {
                    types: ['其他-燈罩', '浮球藝術品'],
                },
            },
            {
                company: {
                    companyId: 3,
                    logoUrl: '',
                    name: '飾不飾獨創設計工作室',
                    introduction:
                        '「飾不飾」工作室-(Alley Design Studio) 坐落於歷史繁華的義重町，今日基隆的義二路商圈上，設計師黃玉婷(Alley)在這老屋空間裡，以工藝創作者、循環再生材質研究者以及青年返鄉的身分，透過手工與風格飾物回到家鄉與民眾進行創作交流，重溫歷史街道的氛圍與別緻。\n\
                        我們希望飾物不再僅是飾物的功能，而有更多的延伸性，效法當代金工的精神，透過飾物可以傳達情感、表現獨特、彰顯風格、關注日常、傳遞精神與理念。在這裡或許可以尋到靈感、體驗生活氛圍，也可以尋到屬於自己的飾物伴侶。人們可以於乘載著各種飾物意義的老屋空間裡，一同觀賞、交流；可以親手打造飾物或選物給最重要的人。\n\
                        除了工作室多元材質的飾物，飾不飾的藝術家-黃玉婷獨家創立了永續珠寶品牌(Vitalité Jewelry)以自然生態為靈感，研發研究了生活環境廢棄塑料並與自身專業工藝技術結合，讓廢棄物轉變為特殊別緻的當代藝術珠寶。希望享美的同時也能讓環境變美。',
                },
                contact: {
                    name: '黃玉婷',
                    department: '設計部',
                    jobTitle: '設計總監',
                    phone: '0989 456 690',
                    email: 'addjewelrydesign@gmail.com',
                },
                product: {
                    types: ['其他'],
                },
            },
        ],
    }
    return { supplyChainData }
}
